import { styled } from '@mui/material/styles'

import Box from '@mui/material/Box'
import { Button } from '@mui/material'
import { gradienteLaranjaIntermediario} from '../../utils/styledVariables'

export const Caixa = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1000,
  '.content': {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: "2em",
    gap: "3em",

    '@media (max-width: 600px)': {
      flexDirection: 'column',
      padding: "0.75em",
      gap: "0.5em",
    },
  },
}))


export const ButtonOff = styled(Button)`
  border: none;
  color: white;
  font-family: 'Inter', sans-serif;
  text-transform: none;
  font-size: 11px;
  font-weight:'medium';
  margin: 5px;
  :hover {
    padding-bottom: 1;
    border-bottom: 2px solid;
    border-radius: 15;
    border-image: ${gradienteLaranjaIntermediario} 1; //linear-gradient(to right, darkblue, darkorchid) 1;
    background: transparent;
  }
  .activeLink {
    background-color: #f05e23;
  }
  .normalLink {
    background-color: #f05e23;
  }
`
export const ButtonOn = styled(Button)`
  border: none;
  color: white;
  font-family: 'Inter', sans-serif;
  padding-bottom: 1;
  border-bottom: 2px solid;
  border-radius: 15;
  border-image: ${gradienteLaranjaIntermediario} 1; //linear-gradient(to right, darkblue, darkorchid) 1;
  background: transparent;
  text-transform: capitalize;
  font-size: 11px;
  font-weight:'medium';
  margin: 5px;
  :hover {
    border: none;
  }
`

